export const campaignEnvironment = {
  edit: 'edit',
  new_empty: 'new_empty',
  duplicate: 'duplicate',
};

export const campaignPanels = {
  main: 'main',
  general: 'general',
  targeting: 'targeting',
  bidding: 'bidding',
  creatives: 'creatives',
  conversionTracking: 'conversionTracking',
  placements: 'placements',
  locations_languages: 'locations_languages',
  devices_os: 'devices_os',
  custom_audience: 'custom_audience',
};

export const allSectionsArr = [
  'main',
  'general',
  'targeting',
  'bidding',
  'creatives',
  'conversionTracking',
];

export const NEW_CAMP_STAB_DEFAULT_TRACKING = {
  Deep_Link: null,
  Impression_Link: null,
  Status: 1,
  TrackingWebsiteToPromote_Link: '',
  Tracking_Link: null,
  UserSet_TrackingLink: false,
  VTA_Link: null,
  bn_bannerid: null,
  bn_id: '',
  isOnBoarding: false,
  preconfigured_tracking_type: 1,
  tracking_company: null,
  tracking_type: '1',
};

export const NEW_CAMP_STAB_DEFAULT_CREATIVE = {
  bn_id: '',
  bn_bannerid: '',
  tmp_id: '',
  name: '',
  banners: [],
  title: 'new title',
  appDescription_new_users: '',
  appDescription_existing_users: '',
  isOnBoarding: '',
  cta_for_ua: 1,
  cta_for_re: 34,
  cta_for_ua_text: 'Install',
  cta_for_re_text: 'Open',
  icon: '',
  image: '',
  status: 1,
  bn_video_url: '',
  bn_video_url_high: '',
  bn_video_url_30sec: '',
  bn_video_url_30sec_high: '',
  movie15_loading_time: null,
  is_vid15_failed: false,
  movie30_loading_time: null,
  is_vid30_failed: false,
  is_custom_tracking: false,
  customTrackingObject: NEW_CAMP_STAB_DEFAULT_TRACKING,
  video_landscape: '',
  video_landscape_media_id: '',
  video_portrait: '',
  video_portrait_media_id: '',
};
